<template>
  <v-app>
    <NavigationDrawer
      :items="items"
      class="navigationDrawer"
    />
    <AppBar
      color="primary"
      appName="my-nsw-gov"
      title="EdPush"
      :searchFilterMutator="false"
      :showFullScreen="false"
      :showNavIcon="true"
    >
      <template slot="appIcon">
        <AppIcon
          appName="my-nsw-gov"
          :transparent="true"
          size="50px"
          class="mt-2"
        />
      </template>

      <template slot="profile">
        <Profile
          class="mr-6"
          :givenName="profile.givenName"
          :surname="profile.sn"
          jobTitle="Admin"
          :updateProfile="false"
          :changePassword="false"
          :updateSecretQuestion="false"
          :portalSettings="false"
          :logout="true"
          :logoutHandler="logout"
        />
      </template>
    </AppBar>

    <v-content class="primary--text">
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>

    <BlockUI v-if="isLoading"/>
  </v-app>
</template>

<script>
import {
  AppBar,
  NavigationDrawer,
  Profile,
  BlockUI,
  AppIcon
} from '@nswdoe/doe-ui-core';

export default {
  name: 'App',
  components: {
    AppBar,
    NavigationDrawer,
    Profile,
    AppIcon,
    BlockUI
  },
  data() {
    return {
      items: [],
      apps: []
    }
  },
  computed: {
    profile() {
      return this.$OAuth.data.profile || {};
    },
    isLoading() {
      return this.$store.getters.isLoading;
    },
    oAuthLoaded() {
      return this.$OAuth.loaded;
    },
    roles() {
      return this.$store.getters.roles;
    }
  },
  watch: {
    async oAuthLoaded(loaded) {
      if (loaded) {
        await this.init();
      }
    },
    roles() {
      if (this.apps.length === 0) {
        if (this.roles.some(role => role.includes('schoolupdate'))) {
        this.apps.push({
          code: 'NSWSchoolsUpdateApp',
          icon: "mdi-list-status",
          title: 'NSW Schools Update App',
          route: "/schoolstatuses",
          clickHandler: () => {
            localStorage.setItem('lastSelectedApp', 'NSWSchoolsUpdateApp');
            this.$store.commit('setSelectedApp', {name: 'NSW Schools Update App', code: 'NSWSchoolsUpdateApp'});
          }
        })
      }
      if (this.roles.some(role => role.includes('staffapp'))) {
        this.apps.push({
          code: 'StaffPortalApp',
          icon: "mdi-cellphone-link",
          title: 'Staff Portal',
          expand: true,
          items: [
            {
              code: 'customNotifications',
              title: "Custom Notifications",
              route: '/notifications',
              clickHandler: () => {
                localStorage.setItem('lastSelectedApp', 'staffPortalApp');
                this.$store.commit('setSelectedApp', {name: 'Staff Portal App', code: 'StaffPortalApp'})
              }
            },
            // {
            //   code: "inAppAlerts",
            //   title: "In-App Alerts",
            //   route: "/app-alerts",
            //   clickHandler: () => {
            //     localStorage.setItem('lastSelectedApp', 'staffPortalApp');
            //     this.$store.commit('setSelectedApp', {name: 'Staff Portal App', code: 'StaffPortalApp'})
            //   }
            // },
            {
              code: "appUpdates",
              title: "App Updates",
              route: "/app-updates",
              clickHandler: () => {
                localStorage.setItem('lastSelectedApp', 'staffPortalApp');
                this.$store.commit('setSelectedApp', {name: 'Staff Portal App', code: 'StaffPortalApp'})
              }
            }
          ]
        });
      }
      if (this.roles.some(role => role.includes('qplus'))) {
        this.apps.push({
          code: "QPlusApp",
          icon: "mdi-cellphone-link",
          title: "Q Plus",
          expand: true,
          items: [
            {
              code: 'customNotifications',
              title: "Custom Notifications",
              route: '/qplus/notifications',
              clickHandler: () => {
                localStorage.setItem('lastSelectedApp', 'qPlusApp');
                this.$store.commit('setSelectedApp', {name: 'Q Plus App', code: 'QPlusApp'})
              }
            }
          ]
        });
      }
      }

      // redirect to the first item if the current path is base
      if (this.$route.name === 'base' && this.apps.length > 0) {
        this.$router.push(this.apps[0].items[0].route);
      }
    }
  },
  async created() {
    if (this.oAuthLoaded) {
      // Sometimes OAuth can already be loaded
      await this.init();
    }
  },
  methods: {
    async init() {
      // fetch roles for the user
      this.$store.dispatch('fetchRoles', this.profile.username);
      this.items = this.apps;
    },
    logout() {
      this.$OAuth.logout();
      return false;
    }
  }
};
</script>

<style lang="scss">
@import './scss/ads.scss';

.v-btn--outlined {
  border-width: 2px !important;
}

.container {
  padding: 0;
  font-family: $body-font-family;
  box-sizing: border-box;
}

.v-input--checkbox label.v-label {
  color: #041E42;
}

.v-input--checkbox .v-input--selection-controls__input i.v-icon {
  color: #041E42;
}

.navigationDrawer > .v-navigation-drawer__content > .v-list > .v-list-item > .row {
  margin: 0 -12px 0 -12px;
}
</style>
